/**
 * 사용자 및 인증 타입 정의
 */
// ---------------------------------------------------------------------------
// Enums
// ---------------------------------------------------------------------------
export const UserRole = {
    /** 시스템 전체 관리 */
    ADMIN: 'ADMIN',
    /** 디바이스 제어 가능, 사용자 관리 불가 */
    OPERATOR: 'OPERATOR',
    /** 데이터 조회만 가능 */
    VIEWER: 'VIEWER',
};
/** 계정 승인/활성 상태 */
export const UserStatus = {
    /** 가입 신청 후 관리자 승인 대기 */
    PENDING: 'pending',
    /** 승인 완료·활성 */
    ACTIVE: 'active',
    /** 비활성(휴면) */
    DORMANT: 'dormant',
};
//# sourceMappingURL=user.js.map